import { reactive, computed } from 'vue';
import { required } from '@vuelidate/validators';

export const experienceForm = reactive({
  position: '',
  company: '',
  sector: '',
  startDate: '',
  endDate: '',
  competencies: [],
  description: ''
});

export const resetExperienceForm = () => {
  experienceForm.position = '';
  experienceForm.company = '';
  experienceForm.sector = '';
  experienceForm.startDate = '';
  experienceForm.endDate = '';
  experienceForm.competencies = [];
  experienceForm.description = '';
};

export const fillExperienceForm = (experience, competenciesItems) => {
  let competenciesIds = [];
  if (experience.technologies) {
    const competencies = experience.technologies.split(';');
    competenciesIds = competencies.map(competency => {
      const competencyItem = competenciesItems.find(item => item.desc === competency);
      return competencyItem ? competencyItem.id : competency;
    });
  }
  experienceForm.position = experience.title;
  experienceForm.company = experience.company;
  experienceForm.sector = experience.sector || '';
  experienceForm.startDate = experience.initDate;
  experienceForm.endDate = experience.endDate;
  experienceForm.description = experience.description;
  experienceForm.competencies = competenciesIds;
};

export const experienceFormRules = computed(() => {
  return {
    position: { required },
    company: { required },
    sector: { required },
    startDate: { required },
    endDate: {},
    competencies: { required },
    description: { required }
  };
});
